(function (angular) {
    'use strict';

    function browserService() {
        /**
         * Determines whether the browser is Internet Explorer
         *
         * @returns {boolean}
         */
        function isIE() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');

            if (msie > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./)) {
                return true;
            }

            return false;
        }

        /**
         * Adds useful classes to the body tag
         *
         * @returns {void}
         */
        function addClasses() {
            if (isIE()) {
                document.body.className += ' ie';
            }
        }

        return {
            isIE: isIE,
            addClasses: addClasses
        };
    }
    browserService.$inject = [];

    angular.module('app')
        .service('Browser', browserService);

}(angular));
